const defaultState = {
  statuses: "ALL",
  vehicleId: "",
  driverId: ""
};

const filters = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_FILTERS":
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default filters;



// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js